import secureStorage from "./encrypt";
import _ from "lodash";
import ReactGA from 'react-ga4';

const domain = window.location.hostname;
if(domain===process?.env?.REACT_APP_OTO_DOMAIN){
	if(!["emp-id","empower-id"].includes(localStorage.getItem("entity_source"))) localStorage.setItem("entity_source","oto-in")
}else if(domain===process?.env?.REACT_APP_TRIV_DOMAIN){
	localStorage.setItem("entity_source","triv-id")
}else if(domain===process?.env?.REACT_APP_FAV_DOMAIN){
	localStorage.setItem("entity_source","fav-id")
}  
export const API_URL = {
  GETWAY_API: process.env.REACT_APP_GETWAY_API,
  COMMON_GATEWAY_API: process.env.REACT_APP_GETWAY_API,
  SFA_HOST: "http://int-sfa-stage.oto.com/",
  GETWAY_BASE_PATH: process.env.REACT_APP_GETWAY_BASE_PATH,
  BASE_PATH_PREFIX: "loan",
  BASE_PATH_PREFIX_HRF: "hrf",
  CHAT_URL: process.env.CHAT_URL || "https://chat.oto.com/",
  CHAT_URL_SOCKET: process.env.CHAT_URL_SOCKET || "https://chat.oto.com/",
  COMMON_GATEWAY_API_EMPOWER: process.env.COMMON_GATEWAY_API_EMPOWER || ""
};

export const SETTING = {
  CRYPTO_KEY: "U*oDwrIU!B#QX37%#24",
  RESEND_OTP_TIME_IN_SECOND: 30,
};

export const RULE_ENGILE = {
  BOOSTER_SCHEME_MAX_VALIDATION: 25000000,
  DEVIATION_AMOUNT_VALIDATION: -10000000
};

export const SITE_CONTENTS = {
  DEALER_SUPPORT_EMAIL: "dealersupport@gaadi.com",
  DEALER_SUPPORT_PHONE: "+919069138803",
  SITE_NAME: "Gaadi Web Pvt. Ltd.",
  SITE_ADDRESS:
    "Floor 2nd. Plot No. - 48, Opposite EPFO Building, Behind Hotel Taj Vivanta, Sector - 44, Gurgaon- 122003, Haryana, India"
};

export const MOBILE_VLIDATION_RULE = /^[8]\d{8,11}$/;

export const MARGIN_FOR_OTO_MAX_VALIDATION = 1000000;

export const NAME_VALIDATION = /^[a-zA-Z .]+$/;

export const ALPHA_NUMERIC_VALIDATION = /^[a-zA-Z0-9 ]+$/;

export const ALPHA_NUMERIC_WITH_DOT_VALIDATION = /^[a-zA-Z0-9 .]+$/;

export const NUMERIC_VALIDATION = /^\d+$/;

export const ACCOUNT_NO_VALIDATION = /^\d{10,16}$/;

export const SPOUSE_OFFICE_ADDRESS_VALIDATION = /^[a-zA-Z0-9@%_&*$#!~()<>?+:,;=^?|'-<>.{} ]{1,70}$/;

export const SPOUSE_BUSINESS_VALIDATION = /^[a-zA-Z0-9@%_&*$#!~()<>?+:,;=^?|'-<>.{} ]{1,20}$/;

export const EMERGENCY_CONTACT_NAME_VALIDATION = /^[a-zA-Z0-9@%_&*$#!~()<>?+:,;=^?|'-<>.{} ]{1,50}$/;

export const EMERGENCY_CONTACT_ADDRESS_VALIDATION = /^[a-zA-Z0-9@%_&*$#!~()<>?+:,;=^?|'-<>.{} ]{1,70}$/;

// export const MOBILE_VALIDATION_RULE = /^\+?\d{8,11}$/;

export const EMAIL_VALIDATION_RULE = /^[^@]+@[^@]+\.[^@]+$/;

export const IS_FAVOURITE_LOGIN = () => {	
	let entity_source = localStorage.getItem("entity_source")
	return API_URL.GETWAY_BASE_PATH === 'favourite_id' || entity_source === "fav-id";
};
export const IS_TRIIVCO_LOGIN = () => {	
	let entity_source = localStorage.getItem("entity_source")
	return API_URL.GETWAY_BASE_PATH === 'triv-id' || entity_source === "triv-id";
};

export const IS_EMPOWER_LOGIN = () => {
	let entity_source = localStorage.getItem("entity_source")	
	return API_URL.GETWAY_BASE_PATH === 'empower_id' || entity_source === "emp-id";
}

export const IS_OTO_LOGIN = () => {
	let entity_source = localStorage.getItem("entity_source")
	return entity_source === "oto-in";
}

export const SHOW_TEXT_LABEL = () => {
	if (IS_FAVOURITE_LOGIN()) {
		return {
			platinum: "Platinum",
			aro: "ARO",
			dsa: "DSA MO",
			dsa_mm: "DSA MM"
		}
	}if (IS_EMPOWER_LOGIN()) {
		return {
			platinum: "Alpha",
			dsa: "MAC",
			aro: "KAO",
		}
	}else{
		return {
			platinum: "Alpha",
			aro: "ARO",
			dsa: "DSA"
		}
	}
};

export const SHOW_USER_ROLE_NAME = (is_config = false) => {
	if ((IS_FAVOURITE_LOGIN())) {
		return {
			AMF: is_config ? "AMF" : "AM",
			BM: "MM",
			AM: is_config ? "RM" : "ARM",
			DZM: "DZM",
			ZM: is_config ? "GM" : "RM",
			RBH: "RBH",
			AGENT_BRO: "FA/PA/MO",
			ARO:"MO",
			RM:"RM",
			ALPHA_AGENT:"Platinum Agent"
		}
	}
	else if (IS_EMPOWER_LOGIN()) {
		return {
			AMF: "AMF",
			BM: "BM",
			AM: "AM",
			DZM: "DZM",
			ZM: "RM",
			RBH: "RBH",
			AGENT_BRO: "Agent",
			ARO: "KAO",
			RM:"RM",
			ALPHA_AGENT:"ALPHA AGENT",
		}
	}
	else{
		return {
			BM: "BM",
			DZM: "DZM",
			ZM: "ZM",
			AM: "AM",
			RBH: "RBH",
			AGENT_BRO: "Agent/BRO",
			ARO:"ARO",
			RM:"RM",
			ALPHA_AGENT:"ALPHA AGENT",
		}
	}
};

export const SHOW_USER_ROLE_NAME_UCF = () => {
	if (IS_FAVOURITE_LOGIN()) {
		return {
			AMF: "AM",
			BM: "MM",
			ZM: "RM",
			AM: "ARM",
			RBH: "RBH",
			AGENT: "FA",
			BRO: "MO",
			ARO:"ARO",
			ARCO:"ARCO",
			ALPHA_AGENT:"Platinum Agent"
		}
	}else if(IS_TRIIVCO_LOGIN()){
		return {
			BM: "BM",
			ZM: "ZM",
			AM: "AM",
			RBH: "RBH",
			AGENT: "Agent",
			BRO: "BRO",
			ARO:"ARO",
			ARCO:"ARCO",
			ALPHA_AGENT:"ALPHA AGENT",
			AMF: "AMF",
		}
	}else{
		return {
			BM: "BM",
			ZM: "ZM",
			DZM: "DZM",
			AM: "AM",
			RBH: "RBH",
			AGENT: "Agent",
			BRO: "BRO",
			ARO:"ARO",
			ARCO:"ARCO",
			ALPHA_AGENT:"ALPHA AGENT",
			AMF: "AMF",
		}
	}
};
export const SFA_ROLE_NAME_DISPLAY = {
    '50':'VP',
    '51':'RBH',
    '56':IS_FAVOURITE_LOGIN() ? 'RM' :'AM',
    '52':IS_FAVOURITE_LOGIN() ? 'MM' :'BM',
    '53': IS_TRIIVCO_LOGIN() ? 'TOS' : IS_FAVOURITE_LOGIN() ? 'FA' :'AGENT',
    '54': 'BRO',
    '57':IS_FAVOURITE_LOGIN() ? 'MO' : "ARO",
    '58': IS_FAVOURITE_LOGIN() ? 'GM' :'ZM',
    '59':"ARCO",
    '46': IS_FAVOURITE_LOGIN() ? 'Platinum Agent' :'ALPHA AGENT',
    '60': "AMF",
    '61': "DZM"
}

export const IS_USER_ACCESS_PAGE = (controller, action) => {
	let isUserHasRights = false, isEditAccess = false;
	let loginData = secureStorage.getItem("loginUserInfo");
	let isSuperAdmin = loginData && loginData.data && loginData.data.user_data && loginData.data.user_data.role_id === -1;
	if (isSuperAdmin) {
		isUserHasRights = true;
		isEditAccess = true;
	} else {
		const userAccessFeatures = secureStorage.getItem("userAccess");
		// console.log(userAccessFeatures,"userAccessFeatures>")
		if (userAccessFeatures && userAccessFeatures.length) {
			let isKeyExist = _.findKey(userAccessFeatures, function (v) {
				if (controller && v.controller && action && v.action) {
					return (
						v.controller.toLowerCase() === controller.toLowerCase() && 
						v.action.toLowerCase() === action.toLowerCase()
					);
				}
			});
			isUserHasRights = isKeyExist ? true : false;
			isEditAccess = isKeyExist ? ((Number(userAccessFeatures[isKeyExist].access_type) === 1) ? true : false) : false
		}
	}
	if(controller === 'UpdateLead' && loginData && loginData.data && loginData.data.user_data && loginData.data.user_data.user_id === 16){
		isEditAccess = true
		isUserHasRights = true 
	} 

	if(controller === 'UpdateLead' && loginData && loginData.data && loginData.data.user_data && loginData.data.user_data.user_id === 16){
		isEditAccess = true
		isUserHasRights = true 
	} 

	return {
		is_access_page: isUserHasRights,
		is_edit_access: isEditAccess,
		isSuperAdmin:isSuperAdmin,
		user_data:loginData?.data?.user_data || {}
	};
};


export const CHECK_ASSIGN_USER = (assign_to) => {
	let loginData = secureStorage.getItem("loginUserInfo");
	let isSuperAdmin = loginData && loginData.data && loginData.data.user_data && (loginData.data.user_data.role_id === -1 || loginData.data.user_data.role_id===2 || loginData.data.user_data.assigned_role_ids.includes("2"));
	if(isSuperAdmin) return false;
	return !(assign_to===loginData?.data?.user_data?.user_id);
};

export const DOWNLOAD_MERGED_PDF = async (urls,loan_id) => {
	const buffers = await Promise.all(urls.map(async (u) => {
		const res = await fetch(u);
		if (!res.ok) throw new Error(`Failed to fetch ${u}`);
		return res.arrayBuffer();
	}));

	const { PDFDocument } = await import('pdf-lib');
	const mergedPdf = await PDFDocument.create();
	for (const buf of buffers) {
		const doc = await PDFDocument.load(buf);
		const pages = await mergedPdf.copyPages(doc, doc.getPageIndices());
		pages.forEach(p => mergedPdf.addPage(p));
	}
	const mergedBytes = await mergedPdf.save();

	const blob = new Blob([mergedBytes], { type: 'application/pdf' });
	const url = URL.createObjectURL(blob);
	const a = document.createElement('a');
	a.href = url;
	a.download = `${loan_id}_FPK.pdf`;
	document.body.appendChild(a);
	a.click();
	a.remove();
	URL.revokeObjectURL(url);
};

export const FINANCIER_ARRAY_FOR_RE_PDF_DOWNLOAD = [2, 3, 6, 12, 13, 14, 15, 16, 18, 23, 25, 26, 27 ,31 ,110, 111 , 105, 114, 118, 120, 125, 324, 388, 326, 396];

export const USER_ROLE = () => {
	if (IS_FAVOURITE_LOGIN()) {
		return [
			{ key: "BM", value: "MM", label: "MM" },
			{ key: "AMF", value: "AMF", label: "AM" },
			{ key: "AM", value: "RM", label: "ARM" },
			{ key: "ZM", value: "GM", label: "RM" },
			{ key: "RBH", value: "RBH", label: "RBH" }
		]
	} else if (IS_TRIIVCO_LOGIN()) {
		return [
			{ key: "BM", value: "BM", label: "BM" },
			{ key: "AM", value: "AM", label: "AM" },
			{ key: "ZM", value: "ZM", label: "ZM" },
			{ key: "RBH", value: "RBH", label: "RBH" }
		]
	} else {
		return [
			{ key: "BM", value: "BM", label: "BM" },
			{ key: "AM", value: "AM", label: "AM" },
			{ key: "DZM", value: "DZM", label: "DZM" },
			{ key: "ZM", value: "ZM", label: "ZM" },
			{ key: "RBH", value: "RBH", label: "RBH" }
		]
	}
};

export const FINANCIER_PRODUCT_TYPE_OPTIONS = [
	{ label: "UCF", value: "finance" },
	{ label: "UCRF", value: "refinance" },
	// { label: "UBRF", value: "UBRF" },
	// { label: "INSURANCE", value: "INSURANCE" },
];
//export const TAX_VALUE = 1.09;///// 1.08

//export const FINANCIER_ARRAY_FOR_TAX_BOOSTER = [6,14,30,18,23,27,13,35,32,15,19,3,22,16,25,26,31,110,105,111,114,118,120];

//export const RBH_ID_FOR_TAX_BOOSTER = 891;
export const DATE_FIELD_NAME={
	deviation_approved_date:"Deviation Approved Date",
	payment_request_received_date:"Payment Request Received Date"
}

export const WHATSAPP_URL = "https://web.whatsapp.com/send?text="

export const ADIRA_INTEGRATION_FINANCIER = [13, 35];
export const ADIRA_INTEGRATION_BRANCHES = [299, 300, 302, 304, 306, 324, 325, 489, 3504, 608, 316, 319, 320, 506];

export const ADIRA_MARITAL_STATUS = {
	"1": [
		{ id: "1", label: "Single", value: "Unmarried" },
		{ id: "2", label: "Married", value: "Married" },
		{ id: "3", label: "Widowed without Children", value: "widowed_without_children" },
		{ id: "4", label: "Widowed with Children", value: "widowed_with_children" },
	],
	"2": [
		{ id: "1", label: "SINGLE", value: "Unmarried" },
		{ id: "2", label: "KAWIN", value: "Married" },
		{ id: "3", label: "DUDA/JANDA TANPA ANAK", value: "widowed_without_children" },
		{ id: "4", label: "DUDA/JANDA DGN ANAK", value: "widowed_with_children" },
	]
};

export const IS_ADIRA_FINANCIER = (lead_data) => {
    if(!lead_data) return false;
    let financier_ids= lead_data?.financier_list?.filter((sf)=>sf.is_loan_applied==="yes")?.map((result)=> result.financier_id) || [];
    let branch_ids= lead_data?.financier_list?.filter((sf)=>sf.is_loan_applied==="yes" && ADIRA_INTEGRATION_FINANCIER.includes(sf.financier_id))?.map((result)=> result.branch_id) || [];
    let already_po_arr= lead_data?.financier_list?.filter((sf)=>sf.is_loan_applied==="yes" && ADIRA_INTEGRATION_FINANCIER.includes(sf.financier_id))?.map((result)=> result.already_po) || [];
    let has_rule_engine_arr= lead_data?.leadLoanDetails?.filter((sf)=> ADIRA_INTEGRATION_FINANCIER.includes(sf.quote_financier_id))?.map((result)=> result.has_rule_engine) || [];

    if (!financier_ids.length || !branch_ids.length || !already_po_arr.length || !has_rule_engine_arr.length) {
        return null;
    }
    if (
      ADIRA_INTEGRATION_FINANCIER?.filter(fn=>financier_ids.includes(fn))?.length &&
      ADIRA_INTEGRATION_BRANCHES?.filter(fn=>branch_ids.includes(fn))?.length &&
      (already_po_arr.includes("No") || already_po_arr.includes("NO") || already_po_arr.includes("NA")) &&
      (lead_data.lead_bucket_name || has_rule_engine_arr.includes("1"))
    ) {
      return lead_data?.financier_list?.filter((sf)=>sf.is_loan_applied==="yes" && ADIRA_INTEGRATION_FINANCIER.includes(sf.financier_id))?.[0] || {};
    }
	return false;
}

export const ADMIN_ROLE_ID = 2;

export const ROLE_MANAGEMENT_IDS = {
	ADMIN_ROLE_ID: 2,
	LEAD_MANAGEMENT_ROLE_ID: 3,
	DO_MAKER_ROLE_ID: 4,
	DO_CHECKER_ROLE_ID: 5,
	BACKUP_TEAM_ROLE_ID: 15
};

export const ROLE_MANAGEMENT_SUB_STATUSES = {
	LEAD_MANAGEMENT_ROLE_SUB_STATUS: [1, 2, 3, 4, 5, 6, 7, 24, 25, 36, 8, 9, 26, 27, 50, 59],
	DO_MAKER_ROLE_SUB_STATUS: [10],
	DO_CHECKER_ROLE_SUB_STATUS: [48],
	BACKUP_TEAM_ROLE_SUB_STATUS: [38, 56, 37, 51, 52, 11, 12, 14, 15, 16, 49, 29],
	OPEN_CASES_SUB_STATUS: [7, 26, 8, 9, 27]
};

export const CHECK_RULE_ENGINE_VIEW_ACCESS = () => {
	let haveConfigAccess = false, haveImportAccess = false, haveBoosterAccess = false, haveReassignAccess = false;
	if (
		IS_USER_ACCESS_PAGE("calculator", "core-config").is_access_page ||
		IS_USER_ACCESS_PAGE("config", "deviation-config").is_access_page ||
		IS_USER_ACCESS_PAGE("import", "mmv-mapping").is_access_page ||
		IS_USER_ACCESS_PAGE("email_template_config", "email_template_config").is_access_page || 
		IS_USER_ACCESS_PAGE("payment_request_charge", "payment_request_charge").is_access_page ||
		IS_USER_ACCESS_PAGE("advance_payment_limit", "advance_payment_limit").is_access_page || 
		IS_USER_ACCESS_PAGE("tat_breach_config", "tat_breach_config").is_access_page
	) {
		haveConfigAccess = true;
	}
	if (
		IS_USER_ACCESS_PAGE("import_mrp_table", "import_mrp_table").is_access_page ||
		IS_USER_ACCESS_PAGE("import_mrp_bcamf", "import_mrp_bcamf").is_access_page ||
		IS_USER_ACCESS_PAGE("import_mrp_buana", "import_mrp_buana").is_access_page ||
		IS_USER_ACCESS_PAGE("import_model_code", "import_model_code").is_access_page ||
		IS_USER_ACCESS_PAGE("import_total_loan_amount","import_total_loan_amount").is_access_page ||
		IS_USER_ACCESS_PAGE("import_brand_type", "import_brand_type").is_access_page ||
		IS_USER_ACCESS_PAGE("import_refund_amount", "import_refund_amount").is_access_page || 
		IS_USER_ACCESS_PAGE("dpd_upload", "dpd_upload").is_access_page

	  ) {
		haveImportAccess = true;
	  }
	  if (
		IS_USER_ACCESS_PAGE("import", "update-lead-dealer").is_access_page ||
		IS_USER_ACCESS_PAGE("import", "update-lead-branch").is_access_page
	  ) {
		haveReassignAccess = true;
	  }
	  if (
		IS_USER_ACCESS_PAGE("boosterRanges", "booster-ranges").is_access_page ||
		IS_USER_ACCESS_PAGE("boosterAmount", "booster-amounts").is_access_page ||
		IS_USER_ACCESS_PAGE("dynamicBoosterTiers", "dynamic-booster-tiers").is_access_page 
	  ) {
		haveBoosterAccess = true;
	  }
	  return {
		"config": haveConfigAccess,
		"import": haveImportAccess,
		"reassign": haveReassignAccess,
		"booster": haveBoosterAccess,
		"no-access": !haveConfigAccess && !haveImportAccess && !haveReassignAccess && !haveBoosterAccess
	  }
}

export const IS_STRING_TO_OBJECT = (str) => {
	try {
		return JSON.parse(str);
	} catch (e) {
		return {};
	}
}

export const IS_MPMF_FINANCIER = (lead_data) => {
	if (!lead_data) return false;
	let { transaction_id } = lead_data;
	let financier_ids=lead_data?.financier_list?.filter((sf)=>sf.is_loan_applied==="yes")?.map((result)=> result.financier_id) || [];
	let already_po= lead_data?.financier_list?.filter((sf)=>sf.is_loan_applied==="yes" && sf.financier_id === 15)?.[0]?.already_po || "";
	let has_rule_engine= lead_data?.leadLoanDetails?.filter((sf)=>sf.quote_financier_id === 15)?.[0]?.has_rule_engine || "";
	if (!financier_ids.length || !already_po || !has_rule_engine || !transaction_id) return false;
	if (financier_ids.includes(15) && ["No", "NO", "NA"].includes(already_po) && has_rule_engine === "1") return true;
	else return false;
}

export const BM_ADVANCE_PAYMENT_LIMIT_DEFAULT_SCHEME_ID = 1;
export const DEALER_ADVANCE_PAYMENT_LIMIT_DEFAULT_SCHEME_ID = 2;
export const CURRENCY_SYMBOL= "Rp. ";
export const CURRENCY_SEPARATOR= ".";

export const HO_REFUND_FINANCIER = [13, 32, 35];

export const INTEREST_RATE_CONFIG = {
	min_per: 1,
	max_per: 20
}
export const GA_TRACKING_ID = "G-4K1EG57EP2";
export const TRIGGER_GA_EVENT = (category, label) => {
	ReactGA.event({
		category: category,
		action: `click_${label}`,
		label: label
	})
}
export const AUTH_KEY="lnaprv-3567-8765-4121-appro-b34b-mrp-xywktree234";

export const DOC_BUTTON_NAME = {
	22: "Customer KTP",
	23: "Guarantor/Spouse",
	4: "Company NPWP"
}

export const APPLICATION_MAPPING_FINANCIER = [3,13,15]

export const DIF_BOOSTER_MAXIMUM_LIMIT = 3675000;
export const DIF_BOOSTER_MINIMUM_LIMIT = 10000;
export const BRANCH_REGION_MAPPING = {
	"scheme-1": 0,
	"region-1": 1,
	"region-2": 2,
	"region-3": 3,
	"region-4": 4
}

export const SLAB_DATA_LIMIT = 5;

export const MRP_LIMIT = 300000000

export const WHT_PER_CONFIG = {
	min_per: 0,
	max_per: 100
}

export const REQUIRED_LATITUDE_LONGITUDE_ROLE_IDS = [46,47,48,51]
export const OPSEE_DOC_IDS = {
	'runner_holding_bpkb': 2,
	'bpkb_personal_data': 3,
	'bpkb_car_data': 4,
	'bpkb_detailed_documents': 5,
	'upload_handover_document': 10,
	'upload_handover_proof': 11,
}
export const API_KEY = "d77bc90f-6824-47da-94c2-2930de73daad";

export const VIDEO_DOC=83;
export const FID_DOC_PARENT_ID=74;
export const GOOGLE_MAP_KEY="AIzaSyAihk-PIveay-MIIddFcF8bAnodK0PTwSg";

export let ENTITY = [
  { value: 'pt_carbay_services_indonesia', id: 'pt_carbay_services_indonesia', label: 'PT. Carbay Services Indonesia' },
  { value: 'pt_genta_kreatif_media', id: 'pt_genta_kreatif_media', label: 'PT. Genta Kreatif Media' },
  { value: 'pt_biru_konsultasi_indonesia', id: 'pt_biru_konsultasi_indonesia', label: 'PT. Biru Konsultasi Indonesia' },
  { value: 'pt_danaku_solusi_indonesia', id: 'pt_danaku_solusi_indonesia', label: 'PT. Danaku Solusi Indonesia' },
  { value: 'pt_merah_konsultasi_indonesia', id: 'pt_merah_konsultasi_indonesia', label: 'PT. Merah Konsultasi Indonesia' }
];

if (IS_TRIIVCO_LOGIN()) {
  ENTITY = ENTITY.filter((ele) => ele.id !== 'pt_merah_konsultasi_indonesia');
}
 
// Depricated Modules
// UCF - "/ucf/Advance_Payment_BM","/ucf/ucf_Advance_Payment_Dealer","/ucf/Dealer_Monthly_Incentive_Config"
// UCRF - "/ucrf/Advance_Payment_Limit_BM","/ucrf/Advance_Payment_Limit_Dealer"
export const MENU_LIST = {
	"OTO":["/lead-list","/refinance/lead-list","/bike-refinance/lead-list","/dif-menu","/rule-engine","/refinance/rule-engine","/financier-list","/role-list","/tat-report/finance/period/day/table","/funnel-report","/api-data-config","/user-tat-report","/runner-mapping-list","/ucrf-config","/ubrf-config","/ucrf/Reassign_Branch","/ucrf/Calculator","/ucrf/Refinance","/ucrf/Bonus_Incentive","/ucrf/Incentive_Scheme_Approval","/ucrf/ARO_Incentive","/ucrf/Common_MMV_Mapping","/ucrf/Agent_Fee","/ucrf/Payment_Request_Charges","/ucrf/Tax_Config","/ucrf/Take_Over_Payment_Charge","/ucrf/Email_Template_Config","/ucrf/Extra_Incentive","/ucrf/DSA_incentive_Config","/ucrf/Alpha_incentive_Config","/ucrf/Import_Buana_Daily_Report","/ucf/Calculator","/ucf/Deviation_Config","/ucf/Common_MMV_Mapping","/ucf/Email_Template_Config","/ucf/Payment_Request_Charges","/ucf/HO_Refund_Config","/ucf/Interest_Rate_Config","/ucf/TAT_Breach_Config","/ucf/WHT_Tax_Config","/ucf/import","/ucf/Dealer","/ucf/Branch","/ucf/Ranges","/ucf/Amount","/ucf/Dynamic_BM_Config","/ucrf/Entity_Config_BM","/ucf/MRPtable","/ucf/MRPBCAMFTable","/ucf/ModelCode","/ucf/SMSTable","/ucf/BrandTypeTable","/ucf/RefundAmount","/ucf/UpdateLead","/ucf/BuanaDailyReport","/ucf/SinarmasDailyReport","/ucf/BfiDailyReport","/ucrf/dynamic_booster_config","/ucrf/dynamic_bm_config","/ucf/dynamic_bm_config","/ucf/FidData","/ucf/dynamic_booster_tier" ,"/ucrf/Product_Offering" ,"/ucf/dpd_upload","/ucrf/import_mrp","/ucf/CriData","/ucf/download_dpd_report" , '/ucf/re_calculate_mtd_cm_data','/ucf/re_calculate_lm_cm_data',"/ucrf/WHT","/ucf/product_offering","/housing-refinance/lead-list","/housing-refinance/rule-engine","/hrf/Deviation_Config","/hrf_financier"],

	"TRIV":["/lead-list","/rule-engine","/financier-list","/role-list","/ucf/Calculator","/ucf/Deviation_Config","/ucf/Common_MMV_Mapping","/ucf/Email_Template_Config","/ucf/Payment_Request_Charges","/ucf/Interest_Rate_Config","/ucf/Dealer_Monthly_Incentive_Config","/ucf/TAT_Breach_Config","/ucf/Dealer","/ucf/Branch","/ucf/Ranges","/ucf/Amount","/ucf/dynamic_booster_tier","/ucf/dynamic_bm_config","/ucf/CriData","/ucf/import","/ucf/dpd_upload","/ucf/download_dpd_report","/ucf/FidData","/ucf/product_offering"],

	"FAV":["/lead-list","/refinance/lead-list","/rule-engine","/refinance/rule-engine","/financier-list","/role-list","/ucrf-config","/ucf/Calculator","/ucf/Deviation_Config",	"/ucf/Email_Template_Config","/ucf/Payment_Request_Charges","/ucf/Interest_Rate_Config","/ucf/Dealer_Monthly_Incentive_Config","/ucf/WHT_Tax_Config","/ucf/Dealer","/ucf/Branch","/ucf/Ranges","/ucf/Amount","/ucrf/Reassign_Branch","/ucrf/Refinance","/ucrf/Bonus_Incentive","/ucrf/Incentive_Scheme_Approval","/ucrf/Agent_Fee","/ucrf/Payment_Request_Charges","/ucrf/Tax_Config","/ucrf/Take_Over_Payment_Charge","/ucrf/Email_Template_Config","/ucrf/DSA_incentive_Config","/ucrf/Alpha_incentive_Config","/ucrf/Entity_Config_BM" , "/ucrf/Product_Offering","/ucf/import","/ucf/CriData","/ucf/dpd_upload","/ucf/download_dpd_report","/ucf/FidData","/ucrf/WHT","/ucrf/dsa_mo","/housing-refinance/lead-list","/housing-refinance/rule-engine","/hrf/Deviation_Config","/hrf_financier"],

	"EMPOWER":["/refinance/lead-list","/refinance/rule-engine","/financier-list","/role-list","/ucrf-config","/ucrf/Reassign_Branch","/ucrf/Refinance","/ucrf/Bonus_Incentive","/ucrf/Incentive_Scheme_Approval","/ucrf/ARO_Incentive","/ucrf/Agent_Fee","/ucrf/Payment_Request_Charges","/ucrf/Tax_Config","/ucrf/Take_Over_Payment_Charge","/ucrf/Email_Template_Config","/ucrf/Extra_Incentive","/ucrf/DSA_incentive_Config","/ucrf/Alpha_incentive_Config","/ucrf/Entity_Config_BM", "/ucrf/Product_Offering","/ucf/CriData","/ucf/dpd_upload","/ucf/download_dpd_report","/ucf/import","/ucf/FidData","/ucrf/WHT"]
}
export const PRODUCT_ALLOWED={
	"OTO":["UCF","UCRF","UBRF","IF"],
	"TRIV":["UCF"],
	"FAV":["UCF","UCRF"],
	"EMPOWER":["UCRF"]
}
export const PRODUCT_ALLOWED_FOR_ROLE={
	"OTO":["UCF","UCRF","UBRF","IF","HRF"],
	"TRIV":["UCF"],
	"FAV":["UCF","UCRF","HRF"],
	"EMPOWER":["UCRF"]
}
export const HRF_PRODUCT_ALLOWED={
	"OTO":["HRF"],
	"FAV":["HRF"],
}
export const TRIIVCO_ZM_IDS4TAXBOOSTER=[992];
export let AGENT_DYNAMIC_BOOSTER_CONFIG_DATA = [
  {
    label: 'Agent Fee',
    AgentFeeTypeTab: 'agent_fee',
  },
  {
    label: 'UCRF Agent Under Regular ARO',
    AgentFeeTypeTab: 'ucrf_agent_under_regular_aro_oto_refinance_dealer',
    agent_fee_type_regular: 'ucrf_agent_under_regular_aro_regular_dealer',
    ucrf_agent_under_regular_aro_oto_refinance_dealer: {
      dealer_column: false,
      aro_column: true,
      agent_column: true,
    },
    ucrf_agent_under_regular_aro_regular_dealer: {
      dealer_column: true,
      aro_column: true,
      agent_column: true,
    },
  },
  {
    label: 'UCRF Agent Under FI ARO',
    AgentFeeTypeTab: 'ucrf_agent_under_regular_fi_aro_oto_refinance_dealer',
    agent_fee_type_regular: 'ucrf_agent_under_regular_fi_aro_regular_dealer',
    ucrf_agent_under_regular_fi_aro_oto_refinance_dealer: {
      dealer_column: false,
      aro_column: true,
      agent_column: true,
    },
    ucrf_agent_under_regular_fi_aro_regular_dealer: {
      dealer_column: true,
      aro_column: true,
      agent_column: true,
    },
  },
  {
    label: 'UCF DSA Agent',
    AgentFeeTypeTab: 'ucf_agent_tagged_dsa_oto_refinance_dealer',
    agent_fee_type_regular: 'ucf_agent_tagged_dsa_regular_dealer',
    ucf_agent_tagged_dsa_oto_refinance_dealer: {
      dealer_column: false,
      aro_column: false,
      agent_column: true,
    },
    ucf_agent_tagged_dsa_regular_dealer: {
      dealer_column: true,
      aro_column: false,
      agent_column: true,
    },
  },
  {
    label: 'UCF Regular Agent',
    AgentFeeTypeTab: 'ucf_agent_not_dsa_oto_refinance_dealer',
    agent_fee_type_regular: 'ucf_agent_not_dsa_regular_dealer',
    ucf_agent_not_dsa_oto_refinance_dealer: {
      dealer_column: false,
      aro_column: false,
      agent_column: true,
    },
    ucf_agent_not_dsa_regular_dealer: {
      dealer_column: true,
      aro_column: false,
      agent_column: true,
    },
  },
  {
    label: 'BRO Regular',
    AgentFeeTypeTab: 'bro_regular_oto_refinance_dealer',
    agent_fee_type_regular: 'bro_regular_regular_dealer',
    bro_regular_oto_refinance_dealer: {
      dealer_column: false,
      aro_column: false,
      agent_column: true,
    },
    bro_regular_regular_dealer: {
      dealer_column: true,
      aro_column: false,
      agent_column: true,
    },
  },
  {
    label: 'BRO Fixed',
    AgentFeeTypeTab: 'bro_fixed_oto_refinance_dealer',
    agent_fee_type_regular: 'bro_fixed_regular_dealer',
    bro_fixed_oto_refinance_dealer: {
      dealer_column: false,
      aro_column: false,
      agent_column: true,
    },
    bro_fixed_regular_dealer: {
      dealer_column: true,
      aro_column: false,
      agent_column: true,
    },
  },
  {
    label: 'UCRF Reguler Agent',
    AgentFeeTypeTab: 'regular_agent_oto_refinance_dealer',
    agent_fee_type_regular: 'regular_agent_regular_dealer',
    regular_agent_oto_refinance_dealer: {
      dealer_column: false,
      aro_column: false,
      agent_column: true,
    },
    regular_agent_regular_dealer: {
      dealer_column: true,
      aro_column: false,
      agent_column: true,
    },
  },
  {
    label: 'UCRF DSA Agent',
    AgentFeeTypeTab: 'dsa_agent_oto_refinance_dealer',
    agent_fee_type_regular: 'dsa_agent_regular_dealer',
    dsa_agent_oto_refinance_dealer: {
      dealer_column: false,
      aro_column: false,
      agent_column: true,
    },
    dsa_agent_regular_dealer: {
      dealer_column: true,
      aro_column: false,
      agent_column: true,
    },
  },
];

if (IS_FAVOURITE_LOGIN() || IS_TRIIVCO_LOGIN() || IS_EMPOWER_LOGIN()) {
  AGENT_DYNAMIC_BOOSTER_CONFIG_DATA = AGENT_DYNAMIC_BOOSTER_CONFIG_DATA.filter((ele) => ele.AgentFeeTypeTab === 'agent_fee');
}
export const VEHICLE_DOC_PARENT_ID=8;

// constant for enc
export const APIV = 2;
export const REQUEST_RESPONSE_ENCRYPTION = {
    aes_algo: "aes-256-cbc",
    response_aes_key: "770A8A65DA156D24EE2A093277530142",
    public_key: "-----BEGIN PUBLIC KEY-----\nMIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQDG2koJfj4vF4UkiSl9vnmznE31\nMV7wslypRbwHEbN0KL4YtpH42euTfTEpD3RuyC3+QG4jHAmtyn+jxQJsZN8/Tq4L\n4N+tp83PZDQoazJDBVDtBCx5Rsyz9P0xemJkbfhbY4LRwQojDYLBlNRI4LHuBnnf\n1sL3PU9daSNQud+GBQIDAQAB\n-----END PUBLIC KEY-----\n",
}

export const CONSENT_DOC_IDS = [95, 96, 97, 98, 99, 100, 101, 102];
export const CBI_CONSENT_FORM_DOC_IDS = [96,97];
export const calculateNetBonusProjectionAmount = (ele) => {
	let net_bonus_projection_amount = 0
	if (ele?.net_bonus_projection_tax_type === 'fixed') {
		net_bonus_projection_amount = parseFloat(ele?.bonus_projection_amount * (1 - ele?.net_bonus_projection_percentage / 100)).toFixed(0);
	}
	return net_bonus_projection_amount;
}

export const MaritalStatus = [
    { id: 1, value: 'Married', label: 'Married' },
    { id: 2, value: 'Unmarried', label: 'Unmarried' },
    { id: 3, value: 'Divorce', label: 'Divorce' },
    {
      id: 4,
      value: 'Widowed',
      label: 'Widowed',
    },
    {
      id: 5,
      value: 'Widower',
      label: 'Widower',
    },
    {
      id: 6,
      value: 'Divorce Alive',
      label: 'Divorce Alive',
    },
    {
      id: 7,
      value: 'Divorce Passed',
      label: 'Divorce Passed',
    },
  ];

export const BFI_CAR_INSURANCE_INCOME_PERCENTAGE = 25;
export const SINARMAS_CAR_INSURANCE_INCOME_PERCENTAGE = 25;
export const SHF_LIFE_INSURANCE_INCOME_PERCENTAGE = 15;
export const SHF_SURVEY_INCOME_DEDUCTABLE_VALUE = 40000;
export const SHF_ADMIN_FEE_INCOME_DEDUCTABLE_VALUE = 1350000;
export const SFA_ROLE_IDS = {
	"ALPHA_AGENT": 46,
	"RBH": 51,
	"BM": 52,
	"AGENT": 53,
	"BRO": 54,
	"AM": 56,
	"ARO": 57,
	"ZM": 58,
	"DZM": 61,
	"ARCO": 59,
	"AMF": 60
}
export const DYNAMIC_BOOSTER_CONFIG_TYPE="ucrf_agent_under_regular_aro_oto_refinance_dealer"